const Class = require('../base/Class');
/**
 * 渲染抽象类
 * @ignore
 * @param {Object} options 构造参数
 * @param {G.Map} options.map  地图对象
 * @param {String} options.id 渲染器id
 * @param {String} options.name 渲染器名称
 * @param {Object} options.eventDispatcher 
 */
let renderer = Class.extend({
    options: {
        zIndex: 1,
    },
    initialize(options) {
        Class.setOptions(this, options);
        //
    },

    /**
     * 销毁
     */
    destroy() {},

    /**
     * 获取图例
     * @method
     */
    getLegends() {},

    /**
     * 添加数据
     * @param list
     */
    add(list) {},

    /**
     * 更新数据
     * @param list
     */
    update(list) {},

    /***
     * 移除单个数据
     * @param id
     */
    remove(id) {},

    /**
     * 清空
     */
    clear() {},


    setVisible(visible) {},

    getVisible() {},

    onResolutionChanged(event) {

    },

    onClick(event) {

    },

    onMouseMove(event) {

    },

    onMouseUp(event) {

    },

    onMouseDown(event) {

    }
});

module.exports = renderer;